import state from './moduleClaimsState.js'
import mutations from './moduleClaimsMutations.js'
import actions from './moduleClaimsActions.js'
import getters from './moduleClaimsGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}